import { useInfiniteQuery } from '@tanstack/react-query'

import { PENDING_FILES_QUERY_KEY } from './pendingFilesQueryKeys'
import { pendingFileListPaginated } from '../../service/pendingFilesService'


type FileListConfig = {
    query: Parameters<typeof pendingFileListPaginated>[0]
    enabled?: boolean
}

export const usePendingFileListPaginated = (config: FileListConfig) => {
    const { query, enabled } = config || {}

    const result = useInfiniteQuery(
        [PENDING_FILES_QUERY_KEY, query],
        ({ pageParam }) => pendingFileListPaginated({
            ...query,
            page: pageParam
        }),
        {
            getNextPageParam: (lastPage) => lastPage ? lastPage.meta.nextPage : 1,
            initialData: () => ({
                pageParams: [1],
                pages: [],
            }),
            enabled,
        }
    )

    return {
        ...result,
        isLoading: result.isLoading || !result.data?.pages.length,
        total: result.data?.pages[0]?.meta?.total,
    }
}

